module.exports = __webpack_public_path__ + "static/img/whyvanilla.f82de05.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/farmImages/whyvanilla.gif
// module id = j/8y
// module chunks = 1